import React from 'react';
import QuerySyntaxRule from '../components/QuerySyntaxRule';
import QueryHelpPageLayout from '../QueryHelpPageLayout';
import {QUERY_HELP_PAGE_INTROS} from '../content/pages';
import {SYNTAX_SECTIONS, SYNTAX_ANTI_PATTERNS, SYNTAX_TIPS} from '../content/syntaxReference';
import QuerySampleCard from '../components/QuerySampleCard';

const SyntaxReferencePage = React.memo(() => (
    <QueryHelpPageLayout
        title="Query syntax"
        intro={QUERY_HELP_PAGE_INTROS.syntax}
    >
        {SYNTAX_SECTIONS.map((section) => (
            <section key={section.id} className="query-help-modal__syntax-section">
                <h4 className="query-help-modal__section-title">{section.title}</h4>
                {section.intro ? (
                    <p className="query-help-modal__section-intro">{section.intro}</p>
                ) : null}
                <div className="query-help-modal__syntax-rules">
                    {section.rules.map((rule) => (
                        <QuerySyntaxRule key={rule.id} rule={rule} />
                    ))}
                </div>
            </section>
        ))}

        <section className="query-help-modal__syntax-section">
            <h4 className="query-help-modal__section-title">Invalid examples</h4>
            <p className="query-help-modal__section-intro">
                These patterns are flagged by the query editor or may perform poorly.
            </p>
            <div className="query-help-modal__sample-list">
                {SYNTAX_ANTI_PATTERNS.map((item) => (
                    <QuerySampleCard key={item.id} item={item} />
                ))}
            </div>
        </section>

        {SYNTAX_TIPS.map((item) => (
            <QuerySampleCard key={item.id} item={item} />
        ))}
    </QueryHelpPageLayout>
));

export default SyntaxReferencePage;
